module.exports = __webpack_public_path__ + "media/images/common/data_none-b5f91c45d0b1746af45455e7bf7e8b71.png";